module.exports = __webpack_public_path__ + "img/telemetry.dab23b12.jpg";